// extracted by mini-css-extract-plugin
export default {"TargetsPanelText":"TargetsPanel-module__TargetsPanelText--OUbdV","TargetsPanelHeading":"TargetsPanel-module__TargetsPanelHeading--Xasss"};